import React, { useState } from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import CustomerList from './customer/CustomerList';
import CustomerDetail from './customer/CustomerDetail';
import CustomerForm from './customer/CustomerForm';
import CustomerMetafieldsEdit from './customer/CustomerMetafieldsEdit';
import CustomerWarranties from './customer/CustomerDetail';
import WarrantyForm from './warranty/WarrantyForm';
import WarrantyList from './warranty/WarrantyList';
import WarrantyDetail from './warranty/WarrantyDetail';
import RepairList from './repair/RepairList';
import RepairDetail from './repair/RepairDetail';
import Logs from './admin/Logs';
import UserManagement from './admin/UserManagement';
import ApiKeyManagement from './admin/ApiKeyManagement';
import Dashboard from './Dashboard';
import './Dashboard.css';

const CustomerDashboard = ({ token, user, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className={`dashboard ${sidebarOpen ? '' : 'sidebar-closed'}`}>
      <nav className="sidebar">
        <div className="sidebar-header">
          <h3>保養單系統</h3>
          <div className="user-info">
            <span>{user?.username || '用戶'}</span>
            <span className="role-badge">{user?.role || '用戶'}</span>
          </div>
        </div>
        <ul className="sidebar-menu">
          {/* <li>
            <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>
              儀表板
            </NavLink>
          </li> */}
          <li>
            <NavLink to="/customers" className={({ isActive }) => isActive ? 'active' : ''}>
              客戶管理
            </NavLink>
          </li>
          <li>
            <NavLink to="/warranties" className={({ isActive }) => isActive ? 'active' : ''}>
              保養單列表
            </NavLink>
          </li>
          <li>
            <NavLink to="/repairs" className={({ isActive }) => isActive ? "active" : ""}>
              維修單管理
            </NavLink>
          </li>
          {user?.role === 'admin' && (
            <>
              <li>
                <NavLink to="/logs" className={({ isActive }) => isActive ? 'active' : ''}>
                  操作日誌
                </NavLink>
              </li>
              <li>
                <NavLink to="/api-keys" className={({ isActive }) => isActive ? 'active' : ''}>
                  API密鑰管理
                </NavLink>
              </li>
              <li>
                <NavLink to="/users" className={({ isActive }) => isActive ? 'active' : ''}>
                  用戶管理
                </NavLink>
              </li>
            </>
          )}
        </ul>
        <div className="sidebar-footer">
          <button onClick={onLogout} className="logout-button">
            退出登錄
          </button>
        </div>
        <button className="toggle-sidebar" onClick={toggleSidebar}>
          {sidebarOpen ? '<<' : '>>'}
        </button>
      </nav>

      <main className="content">
        <Routes>
          {/* <Route path="/" element={<Dashboard token={token} user={user} />} /> */}
          <Route path="/" element={<CustomerList token={token} user={user} />} />
          <Route path="/customers" element={<CustomerList token={token} user={user} />} />
          <Route path="/customers/add" element={<CustomerForm token={token} user={user} />} />
          <Route path="/customers/:customerId" element={<CustomerDetail token={token} user={user} />} />
          <Route path="/customers/:customerId/edit" element={<CustomerForm token={token} user={user} />} />
          <Route path="/customers/:customerId/metafields" element={<CustomerMetafieldsEdit token={token} user={user} />} />
          <Route path="/customers/:customerId/warranties" element={<CustomerDetail token={token} user={user} warrantyView={true} />} />
          <Route path="/customers/:customerId/warranties/add" element={<WarrantyForm token={token} user={user} />} />
          <Route path="/warranties" element={<WarrantyList token={token} user={user} />} />
          <Route path="/warranties/:warrantyId" element={<WarrantyDetail token={token} user={user} />} />
          <Route path="/repairs" element={<RepairList token={token} user={user} />} />
          <Route path="/repairs/:repairId" element={<RepairDetail token={token} user={user} />} />
          {/* 只有管理員可以訪問的路由 */}
          {user?.role === 'admin' ? (
            <>
              <Route path="/logs" element={<Logs token={token} user={user} />} />
              <Route path="/api-keys" element={<ApiKeyManagement token={token} />} />
              <Route path="/users" element={<UserManagement token={token} />} />
              {/* 保留舊路徑的兼容性 */}
              <Route path="/add-user" element={<Navigate to="/users" replace />} />
            </>
          ) : (
            <>
              <Route path="/logs" element={<Navigate to="/" replace />} />
              <Route path="/api-keys" element={<Navigate to="/" replace />} />
              <Route path="/users" element={<Navigate to="/" replace />} />
              <Route path="/add-user" element={<Navigate to="/" replace />} />
            </>
          )}

          {/* 捕獲所有其他路由 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
};

export default CustomerDashboard;
